'use client';
import { useContext } from 'react';
import { ExperimentContext } from '../experiment-provider/ExperimentProvider';
export const useExperimentFlag = (flagKey, expectedValue) => {
    var _a;
    const { client, variants, isLoading, allowTracking } = useContext(ExperimentContext);
    const { value: flagValue } = (variants === null || variants === void 0 ? void 0 : variants[flagKey]) || {};
    const isEnabled = flagValue === expectedValue;
    if (!isLoading) {
        flagValue && allowTracking && ((_a = client === null || client === void 0 ? void 0 : client.exposure) === null || _a === void 0 ? void 0 : _a.call(client, flagKey));
    }
    return { isEnabled, value: flagValue, isLoading };
};
